















































import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  ProductionOrderProcessWorkStationRecordServiceProxy,
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import { FieldSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { ScrappedTypeServiceProxy } from '@/service-proxies/app-v2/qc.service-proxies'
import dayjs from 'dayjs'
import { exportProcessHistory } from '@/api/api'
import ScrapModal from './scrapModal.vue'
const popwsrsp = new ProductionOrderProcessWorkStationRecordServiceProxy()
const stsp = new ScrappedTypeServiceProxy()
const fssp = new FieldSettingServiceProxy()
const planStatusMap = {
  1: 'page_work_no',
  2: 'page_work_yes',
  3: 'page_work_done',
}

@Component({
  components: {
    ScrapModal
  }
})
class RecordButton extends Vue {
  @Prop() orderId: string
  @Prop() disabled: boolean

  visible = false
  loading = false
  scrapVisible = false

  remarkVisible = false
  remarkLoading = false
  remark = ''
  scrapType = []

  recordId = ''
  record = {}
  currentRecord: any = {}
  extraCols = []

  get planTypeId() {
    const chars = this.$route.path.split('/')
    return chars[chars.length - 1]
  }
  scrapCancel() {
    this.scrapVisible = false
    this.fetchData()
  }
  saveScrap() {

  }
  get columns() {
      return [
        {
          title: this.$t('actions'),
          key: 'action',
          customRender: (_, record) => {
            const { $createElement: h } = this
            let saveString = ''
            let cancelString = ''
            let reString = ''
            const a = this.$t('save')
            const b = this.$t('cancel')
            const c = this.$t('edit')
            if (typeof a === 'string') {
              saveString = a
            }
            if (typeof b === 'string') {
              cancelString = b
            }
            if (typeof c === 'string') {
              reString = c
            }
            if (record.status === 3) {
              return (
                <div>
                  <a v-acl={'page_work_report_again_' + this.planTypeId} onClick={() => {
                    record.isEdit = true
                    this.scrapVisible = true
                    this.record = record
                    stsp.getPageScrappedReason(1, '', -1).then(res => {
                      this.scrapType = res.records
                    })
                  }}>
                    {reString}
                  </a>
                  <a-divider v-acl={'page_work_history_delete_' + this.planTypeId} type="vertical"></a-divider>
                  <a-popconfirm
                    v-acl={'page_work_history_delete_' + this.planTypeId}
                    title={this.$t('page_resource_pool_confirm_delete')}
                    ok-text={this.$t('yes')}
                    cancel-text={this.$t('no')}
                    onConfirm={() => this.del(record)}
                  >
                    <a style="color: var(--color-red)">{this.$t('delete')}</a>
                  </a-popconfirm>
                </div>
              )
            } else {
              return '-'
            }
          },
          width: 100,
          ellipsis: true,
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 100,
          ellipsis: true,
        },
        {
          title: '产品规格',
          dataIndex: 'standardModel',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('page_process_management'),
          dataIndex: 'processCode',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('page_workstation_management'),
          dataIndex: 'workStationName',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('page_plan_process_persoal'),
          dataIndex: 'producerName',
          width: 100,
          ellipsis: true,
        },
        {
          title: '指派数量',
          dataIndex: 'workStationAssignNum',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('page_work_order_report_num'),
          dataIndex: 'reportNum',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('page_plan_qualified_number'),
          dataIndex: 'qualifyNum',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('page_collection_quantity'),
          dataIndex: 'collectionNum',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('page_plan_scrap_number'),
          dataIndex: 'scrappedNum',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('page_work_reporting_hours'),
          dataIndex: 'reportWorkingHours',
          customRender: val => {
            return this.getTime(val)
          },
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t('page_work_start_time'),
          dataIndex: 'startTime',
          customRender: val => {
            return dayjs(val).format('YYYY-MM-DD HH:mm:ss')
          },
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t('page_work_report_time'),
          dataIndex: 'endTime',
          customRender: val => {
            return val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : ''
          },
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t('page_resource_pool_status'),
          dataIndex: 'status',
          customRender: val => {
            return this.$t(planStatusMap[val])
          },
          // width: 120,
          ellipsis: true,
        },
        ...this.extraCols,
        {
          title: this.$t('remark'),
          dataIndex: 'remark',
          width: 200,
          ellipsis: true,
        }
      ]
  }
  tableData: any[] = []
  pagination = { current: 1, pageSize: 10, total: 0 }

  // 获取用户自定义字段
  async getExtraFields() {
    let extraCols = []
    let res = await fssp.listFieldSettings('page_plan_report_work_order')
    res.map(item => {
      if (item.isDisplay) {
        extraCols.push({
          title: item.name,
          key: item.code,
          dataIndex: item.code,
          ellipsis: true,
          width: 120
        })
      }
    })
    this.extraCols = extraCols
  }

  openModal() {
    this.visible = true
    this.pagination.current = 1
    this.fetchData()
    this.getExtraFields()
  }
  exportList () {
    exportProcessHistory(this.orderId, 'page_plan_report_work_order').then( (res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `报工历史.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }))

  }
  ok() {
    this.visible = false
  }

  cancel() {
    this.visible = false
    this.$emit('refresh')
  }

  async del(record) {
    this.loading = true
    try {
      await popwsrsp.deleteRecordReportWork(record.id)
      this.$message.success(this.$t('delete_success'))
      this.fetchData()
    } catch (e) {
      this.loading = false
    }
  }
  getTime(val) {
  var days = val / 1000 / 60 / 60 / 24;
  var daysRound = Math.floor(days);
  var hours = val / 1000 / 60 / 60 - (24 * daysRound);
  var hoursRound = Math.floor(hours);
  var minutes = val / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
  var minutesRound = Math.floor(minutes);
  var seconds = val / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
  var time = daysRound + '/' + hoursRound + '/' + minutesRound + '/' + seconds
  // var time = daysRound + '天'+ hoursRound + '时'+ minutesRound + '分'+ seconds + '秒'
  return time;
  }

  async fetchData() {
    this.loading = true
    try {
      const res = await popwsrsp.orderProcessRecord(this.pagination.current, this.orderId, this.pagination.pageSize)
      this.tableData = res.records.map(record => ({
        ...record,
        isEdit: false,
        _qualifyNum: record.qualifyNum,
        _scrappedNum: record.scrappedNum,
      }))
      // this.tableData = this.tableData.concat({ id: 1 })
      this.pagination.total = Number(res.total)
      this.pagination.current = Number(res.current)
    } finally {
      this.loading = false
    }
  }

  onTableChange(e) {
    this.pagination = e
    this.fetchData()
  }

  async updateRemark() {
    const body: any = { id: this.recordId, remark: this.remark }
    this.remarkLoading = true
    try {
      await popwsrsp.addRecordRemark(body)
      this.remarkVisible = false
      this.recordId = ''
      this.currentRecord.remark = this.remark
      this.currentRecord = {}
      this.$message.success(this.$t('page_mdc_realtime_success'))
    } catch (e) {
      this.$message.error(this.$t('page_log_management_fail'))
    } finally {
      this.remarkLoading = false
    }
  }
}
export default RecordButton
